

export const linkNames = [
    {
        heading: "About us",
        
        to : "/about"
      },
      {
        heading: "Area of Operation",
        
        to : "#area"
      },
      {
        heading: "Projects",
        
        to : "#project"
      },
      {
        heading: "Sustainability",
        to: "/sustainability"
        
      },
      {
        heading: "Clients",
        to:"#clients"
      },
      {
        heading: "Contacts",
        to :"#contact",
      },
      {
        heading: "Careers",
        to:"/career",
      },
]